import type { LocationResponse, MembershipRole } from "@safeplate/contracts";
import { createContext, useContext } from "react";

export interface ShellContextValue {
  activeLocation: LocationResponse | null;
  activeOrganisationId: string;
  activeRole: MembershipRole;
  authMethod: "primary" | "shared_pin";
  locationError: unknown;
  locations: readonly LocationResponse[];
  locationsPending: boolean;
  ownStaffProfileIds: readonly string[];
  refreshLocations: () => Promise<unknown>;
  selectLocation: (locationId: string) => void;
  userId: string;
  userName: string;
}

export const ShellContext = createContext<ShellContextValue | null>(null);

export function useShell(): ShellContextValue {
  const context = useContext(ShellContext);
  if (!context) {
    throw new Error("useShell must be used inside AppShell");
  }
  return context;
}
